/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: userActionLogContextQuery
// ====================================================

export interface userActionLogContextQuery_userActionLog_logRecords_user {
  __typename: "User";
  uid: GraphQlLong;
  login: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignTimeTargetEvent_campaign {
  __typename: "CampaignView";
  id: GraphQlLong;
  name: string;
  calcType: CalcType;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignTimeTargetEvent_oldTimeTarget_timeZone {
  __typename: "TimeZoneView";
  id: GraphQlLong;
  name: string | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignTimeTargetEvent_oldTimeTarget {
  __typename: "TimeTargetView";
  timeZone: userActionLogContextQuery_userActionLog_logRecords_event_CampaignTimeTargetEvent_oldTimeTarget_timeZone;
  monday: (number | null)[];
  tuesday: (number | null)[];
  wednesday: (number | null)[];
  thursday: (number | null)[];
  friday: (number | null)[];
  saturday: (number | null)[];
  sunday: (number | null)[];
  workingWeekend: (number | null)[];
  holiday: (number | null)[];
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignTimeTargetEvent_newTimeTarget_timeZone {
  __typename: "TimeZoneView";
  id: GraphQlLong;
  name: string | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignTimeTargetEvent_newTimeTarget {
  __typename: "TimeTargetView";
  timeZone: userActionLogContextQuery_userActionLog_logRecords_event_CampaignTimeTargetEvent_newTimeTarget_timeZone;
  monday: (number | null)[];
  tuesday: (number | null)[];
  wednesday: (number | null)[];
  thursday: (number | null)[];
  friday: (number | null)[];
  saturday: (number | null)[];
  sunday: (number | null)[];
  workingWeekend: (number | null)[];
  holiday: (number | null)[];
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignTimeTargetEvent {
  __typename: "CampaignTimeTargetEvent";
  category: OutputCategory;
  clientId: GraphQlLong;
  campaign: userActionLogContextQuery_userActionLog_logRecords_event_CampaignTimeTargetEvent_campaign;
  oldTimeTarget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignTimeTargetEvent_oldTimeTarget;
  newTimeTarget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignTimeTargetEvent_newTimeTarget;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignBroadMatchEvent_campaign {
  __typename: "CampaignView";
  id: GraphQlLong;
  name: string;
  calcType: CalcType;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignBroadMatchEvent_oldBroadMatch_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignBroadMatchEvent_oldBroadMatch {
  __typename: "BroadMatchView";
  enabled: boolean;
  isLimitDefined: boolean;
  limit: number;
  goal: userActionLogContextQuery_userActionLog_logRecords_event_CampaignBroadMatchEvent_oldBroadMatch_goal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignBroadMatchEvent_newBroadMatch_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignBroadMatchEvent_newBroadMatch {
  __typename: "BroadMatchView";
  enabled: boolean;
  isLimitDefined: boolean;
  limit: number;
  goal: userActionLogContextQuery_userActionLog_logRecords_event_CampaignBroadMatchEvent_newBroadMatch_goal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignBroadMatchEvent {
  __typename: "CampaignBroadMatchEvent";
  category: OutputCategory;
  clientId: GraphQlLong;
  campaign: userActionLogContextQuery_userActionLog_logRecords_event_CampaignBroadMatchEvent_campaign;
  oldBroadMatch: userActionLogContextQuery_userActionLog_logRecords_event_CampaignBroadMatchEvent_oldBroadMatch;
  newBroadMatch: userActionLogContextQuery_userActionLog_logRecords_event_CampaignBroadMatchEvent_newBroadMatch;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignNetworkEvent_campaign {
  __typename: "CampaignView";
  id: GraphQlLong;
  name: string;
  calcType: CalcType;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignNetworkEvent_oldNetwork {
  __typename: "NetworkView";
  type: NetworkViewType;
  limitPercent: number;
  priceCoef: number;
  enableCpcHold: boolean;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignNetworkEvent_newNetwork {
  __typename: "NetworkView";
  type: NetworkViewType;
  limitPercent: number;
  priceCoef: number;
  enableCpcHold: boolean;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignNetworkEvent {
  __typename: "CampaignNetworkEvent";
  category: OutputCategory;
  clientId: GraphQlLong;
  campaign: userActionLogContextQuery_userActionLog_logRecords_event_CampaignNetworkEvent_campaign;
  oldNetwork: userActionLogContextQuery_userActionLog_logRecords_event_CampaignNetworkEvent_oldNetwork;
  newNetwork: userActionLogContextQuery_userActionLog_logRecords_event_CampaignNetworkEvent_newNetwork;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignRegionsEvent_campaign {
  __typename: "CampaignView";
  id: GraphQlLong;
  name: string;
  calcType: CalcType;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignRegionsEvent {
  __typename: "CampaignRegionsEvent";
  category: OutputCategory;
  clientId: GraphQlLong;
  campaign: userActionLogContextQuery_userActionLog_logRecords_event_CampaignRegionsEvent_campaign;
  oldRegions: (number | null)[];
  newRegions: (number | null)[];
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_AdGroupsRegionsEvent_campaign {
  __typename: "CampaignView";
  id: GraphQlLong;
  name: string;
  calcType: CalcType;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_AdGroupsRegionsEvent_adGroups {
  __typename: "AdGroupView";
  id: GraphQlLong | null;
  name: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_AdGroupsRegionsEvent {
  __typename: "AdGroupsRegionsEvent";
  category: OutputCategory;
  clientId: GraphQlLong;
  campaign: userActionLogContextQuery_userActionLog_logRecords_event_AdGroupsRegionsEvent_campaign;
  adGroups: (userActionLogContextQuery_userActionLog_logRecords_event_AdGroupsRegionsEvent_adGroups | null)[];
  oldRegions: (number | null)[];
  newRegions: (number | null)[];
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_DemographyMultipliersEvent_campaign {
  __typename: "CampaignView";
  id: GraphQlLong;
  name: string;
  calcType: CalcType;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_DemographyMultipliersEvent_adGroup {
  __typename: "AdGroupView";
  id: GraphQlLong | null;
  name: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_DemographyMultipliersEvent_oldDemographyMultipliers {
  __typename: "DemographyMultiplierView";
  age: Age;
  gender: Gender;
  multiplier: number;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_DemographyMultipliersEvent_newDemographyMultipliers {
  __typename: "DemographyMultiplierView";
  age: Age;
  gender: Gender;
  multiplier: number;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_DemographyMultipliersEvent {
  __typename: "DemographyMultipliersEvent";
  category: OutputCategory;
  clientId: GraphQlLong;
  campaign: userActionLogContextQuery_userActionLog_logRecords_event_DemographyMultipliersEvent_campaign;
  adGroup: userActionLogContextQuery_userActionLog_logRecords_event_DemographyMultipliersEvent_adGroup;
  oldDemographyMultipliers: (userActionLogContextQuery_userActionLog_logRecords_event_DemographyMultipliersEvent_oldDemographyMultipliers | null)[];
  newDemographyMultipliers: (userActionLogContextQuery_userActionLog_logRecords_event_DemographyMultipliersEvent_newDemographyMultipliers | null)[];
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_RetargetingMultipliersEvent_campaign {
  __typename: "CampaignView";
  id: GraphQlLong;
  name: string;
  calcType: CalcType;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_RetargetingMultipliersEvent_adGroup {
  __typename: "AdGroupView";
  id: GraphQlLong | null;
  name: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_RetargetingMultipliersEvent_oldRetargetingMultipliers {
  __typename: "RetargetingMultiplierView";
  retargetingConditionId: GraphQlLong;
  retargetingConditionName: string;
  multiplier: number;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_RetargetingMultipliersEvent_newRetargetingMultipliers {
  __typename: "RetargetingMultiplierView";
  retargetingConditionId: GraphQlLong;
  retargetingConditionName: string;
  multiplier: number;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_RetargetingMultipliersEvent {
  __typename: "RetargetingMultipliersEvent";
  category: OutputCategory;
  clientId: GraphQlLong;
  campaign: userActionLogContextQuery_userActionLog_logRecords_event_RetargetingMultipliersEvent_campaign;
  adGroup: userActionLogContextQuery_userActionLog_logRecords_event_RetargetingMultipliersEvent_adGroup;
  oldRetargetingMultipliers: (userActionLogContextQuery_userActionLog_logRecords_event_RetargetingMultipliersEvent_oldRetargetingMultipliers | null)[];
  newRetargetingMultipliers: (userActionLogContextQuery_userActionLog_logRecords_event_RetargetingMultipliersEvent_newRetargetingMultipliers | null)[];
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_BannersEvent_campaign {
  __typename: "CampaignView";
  id: GraphQlLong;
  name: string;
  calcType: CalcType;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_BannersEvent_adGroup {
  __typename: "AdGroupView";
  id: GraphQlLong | null;
  name: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_BannersEvent_ads {
  __typename: "AdView";
  id: GraphQlLong;
  title: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_BannersEvent {
  __typename: "BannersEvent";
  category: OutputCategory;
  clientId: GraphQlLong;
  campaign: userActionLogContextQuery_userActionLog_logRecords_event_BannersEvent_campaign;
  adGroup: userActionLogContextQuery_userActionLog_logRecords_event_BannersEvent_adGroup;
  ads: (userActionLogContextQuery_userActionLog_logRecords_event_BannersEvent_ads | null)[];
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignValueChangeEvent_campaign {
  __typename: "CampaignView";
  id: GraphQlLong;
  name: string;
  calcType: CalcType;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignValueChangeEvent {
  __typename: "CampaignValueChangeEvent";
  category: OutputCategory;
  clientId: GraphQlLong;
  campaign: userActionLogContextQuery_userActionLog_logRecords_event_CampaignValueChangeEvent_campaign;
  oldValue: string | null;
  newValue: string | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignListChangeEvent_campaign {
  __typename: "CampaignView";
  id: GraphQlLong;
  name: string;
  calcType: CalcType;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignListChangeEvent {
  __typename: "CampaignListChangeEvent";
  category: OutputCategory;
  clientId: GraphQlLong;
  campaign: userActionLogContextQuery_userActionLog_logRecords_event_CampaignListChangeEvent_campaign;
  oldList: (string | null)[];
  newList: (string | null)[];
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStatusChangeEvent_campaign {
  __typename: "CampaignView";
  id: GraphQlLong;
  name: string;
  calcType: CalcType;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStatusChangeEvent {
  __typename: "CampaignStatusChangeEvent";
  category: OutputCategory;
  clientId: GraphQlLong;
  campaign: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStatusChangeEvent_campaign;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_campaign {
  __typename: "CampaignView";
  id: GraphQlLong;
  name: string;
  calcType: CalcType;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpa_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpa_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpa {
  __typename: "GdCampaignStrategyAvgCpa";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpa_budget | null;
  goalId: GraphQlLong | null;
  goal: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpa_goal;
  bid: GraphQlBigDecimal | null;
  avgCpa: GraphQlBigDecimal | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpaPerFilter_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpaPerFilter_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpaPerFilter {
  __typename: "GdCampaignStrategyAvgCpaPerFilter";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpaPerFilter_budget | null;
  filterAvgCpa: GraphQlBigDecimal | null;
  filterAvgBid: GraphQlBigDecimal | null;
  goalId: GraphQlLong | null;
  goal: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpaPerFilter_goal;
  bid: GraphQlBigDecimal | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpcPerFilter_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpcPerFilter {
  __typename: "GdCampaignStrategyAvgCpcPerFilter";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpcPerFilter_budget | null;
  bid: GraphQlBigDecimal | null;
  filterAvgBid: GraphQlBigDecimal | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpaPerCamp_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpaPerCamp_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpaPerCamp {
  __typename: "GdCampaignStrategyAvgCpaPerCamp";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpaPerCamp_budget | null;
  goalId: GraphQlLong | null;
  goal: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpaPerCamp_goal;
  bid: GraphQlBigDecimal | null;
  avgCpa: GraphQlBigDecimal | null;
  avgBid: GraphQlBigDecimal | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpcPerCamp_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpcPerCamp {
  __typename: "GdCampaignStrategyAvgCpcPerCamp";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpcPerCamp_budget | null;
  bid: GraphQlBigDecimal | null;
  avgBid: GraphQlBigDecimal | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgClick_budget | null;
  avgBid: GraphQlBigDecimal | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpm_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpm {
  __typename: "GdCampaignStrategyAvgCpm";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpm_budget | null;
  avgCpm: GraphQlBigDecimal | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyWeekBudget_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyWeekBudget_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyWeekBudget {
  __typename: "GdCampaignStrategyWeekBudget";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyWeekBudget_budget | null;
  bid: GraphQlBigDecimal | null;
  goalId: GraphQlLong | null;
  goal: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyWeekBudget_goal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyWeekBundle_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyWeekBundle {
  __typename: "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyWeekBundle_budget | null;
  clicksLimit: GraphQlLong | null;
  bid: GraphQlBigDecimal | null;
  avgBid: GraphQlBigDecimal | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyRoi_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyRoi_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyRoi {
  __typename: "GdCampaignStrategyRoi";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyRoi_budget | null;
  profitability: GraphQlBigDecimal | null;
  roiCoef: GraphQlBigDecimal | null;
  goalId: GraphQlLong | null;
  goal: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyRoi_goal;
  bid: GraphQlBigDecimal | null;
  reserveReturn: GraphQlLong | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpi_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpi {
  __typename: "GdCampaignStrategyAvgCpi";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpi_budget | null;
  bid: GraphQlBigDecimal | null;
  avgCpi: GraphQlBigDecimal;
}

export type userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy = userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpa | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpaPerFilter | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpcPerFilter | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpaPerCamp | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpcPerCamp | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgClick | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpm | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyWeekBudget | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyWeekBundle | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyRoi | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyManual | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy_GdCampaignStrategyAvgCpi;

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpa_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpa_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpa {
  __typename: "GdCampaignStrategyAvgCpa";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpa_budget | null;
  goalId: GraphQlLong | null;
  goal: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpa_goal;
  bid: GraphQlBigDecimal | null;
  avgCpa: GraphQlBigDecimal | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpaPerFilter_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpaPerFilter_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpaPerFilter {
  __typename: "GdCampaignStrategyAvgCpaPerFilter";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpaPerFilter_budget | null;
  filterAvgCpa: GraphQlBigDecimal | null;
  filterAvgBid: GraphQlBigDecimal | null;
  goalId: GraphQlLong | null;
  goal: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpaPerFilter_goal;
  bid: GraphQlBigDecimal | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpcPerFilter_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpcPerFilter {
  __typename: "GdCampaignStrategyAvgCpcPerFilter";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpcPerFilter_budget | null;
  bid: GraphQlBigDecimal | null;
  filterAvgBid: GraphQlBigDecimal | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpaPerCamp_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpaPerCamp_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpaPerCamp {
  __typename: "GdCampaignStrategyAvgCpaPerCamp";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpaPerCamp_budget | null;
  goalId: GraphQlLong | null;
  goal: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpaPerCamp_goal;
  bid: GraphQlBigDecimal | null;
  avgCpa: GraphQlBigDecimal | null;
  avgBid: GraphQlBigDecimal | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpcPerCamp_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpcPerCamp {
  __typename: "GdCampaignStrategyAvgCpcPerCamp";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpcPerCamp_budget | null;
  bid: GraphQlBigDecimal | null;
  avgBid: GraphQlBigDecimal | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgClick_budget | null;
  avgBid: GraphQlBigDecimal | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpm_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpm {
  __typename: "GdCampaignStrategyAvgCpm";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpm_budget | null;
  avgCpm: GraphQlBigDecimal | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyWeekBudget_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyWeekBudget_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyWeekBudget {
  __typename: "GdCampaignStrategyWeekBudget";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyWeekBudget_budget | null;
  bid: GraphQlBigDecimal | null;
  goalId: GraphQlLong | null;
  goal: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyWeekBudget_goal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyWeekBundle_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyWeekBundle {
  __typename: "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyWeekBundle_budget | null;
  clicksLimit: GraphQlLong | null;
  bid: GraphQlBigDecimal | null;
  avgBid: GraphQlBigDecimal | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyRoi_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyRoi_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyRoi {
  __typename: "GdCampaignStrategyRoi";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyRoi_budget | null;
  profitability: GraphQlBigDecimal | null;
  roiCoef: GraphQlBigDecimal | null;
  goalId: GraphQlLong | null;
  goal: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyRoi_goal;
  bid: GraphQlBigDecimal | null;
  reserveReturn: GraphQlLong | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyManual_budget | null;
  separateBidding: boolean | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpi_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpi {
  __typename: "GdCampaignStrategyAvgCpi";
  type: GdCampaignStrategyType;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpi_budget | null;
  bid: GraphQlBigDecimal | null;
  avgCpi: GraphQlBigDecimal;
}

export type userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy = userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpa | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpaPerFilter | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpcPerFilter | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpaPerCamp | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpcPerCamp | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgClick | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpm | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyWeekBudget | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyWeekBundle | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyRoi | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyManual | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy_GdCampaignStrategyAvgCpi;

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent {
  __typename: "CampaignStrategyEvent";
  category: OutputCategory;
  clientId: GraphQlLong;
  campaign: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_campaign;
  currencyCode: CurrencyCode;
  oldFlatStrategy: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_oldFlatStrategy | null;
  newFlatStrategy: userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent_newFlatStrategy | null;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_SingleMultiplierEvent_campaign {
  __typename: "CampaignView";
  id: GraphQlLong;
  name: string;
  calcType: CalcType;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_SingleMultiplierEvent_adGroup {
  __typename: "AdGroupView";
  id: GraphQlLong | null;
  name: string;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_SingleMultiplierEvent {
  __typename: "SingleMultiplierEvent";
  category: OutputCategory;
  clientId: GraphQlLong;
  campaign: userActionLogContextQuery_userActionLog_logRecords_event_SingleMultiplierEvent_campaign;
  adGroup: userActionLogContextQuery_userActionLog_logRecords_event_SingleMultiplierEvent_adGroup;
  oldMultiplier: number;
  newMultiplier: number;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignRestrictFrequencyEvent_campaign {
  __typename: "CampaignView";
  id: GraphQlLong;
  name: string;
  calcType: CalcType;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignRestrictFrequencyEvent_oldRestrictFrequency {
  __typename: "RestrictFrequencyView";
  value: number;
  reset: number;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignRestrictFrequencyEvent_newRestrictFrequency {
  __typename: "RestrictFrequencyView";
  value: number;
  reset: number;
}

export interface userActionLogContextQuery_userActionLog_logRecords_event_CampaignRestrictFrequencyEvent {
  __typename: "CampaignRestrictFrequencyEvent";
  category: OutputCategory;
  clientId: GraphQlLong;
  campaign: userActionLogContextQuery_userActionLog_logRecords_event_CampaignRestrictFrequencyEvent_campaign;
  oldRestrictFrequency: userActionLogContextQuery_userActionLog_logRecords_event_CampaignRestrictFrequencyEvent_oldRestrictFrequency;
  newRestrictFrequency: userActionLogContextQuery_userActionLog_logRecords_event_CampaignRestrictFrequencyEvent_newRestrictFrequency;
}

export type userActionLogContextQuery_userActionLog_logRecords_event = userActionLogContextQuery_userActionLog_logRecords_event_CampaignTimeTargetEvent | userActionLogContextQuery_userActionLog_logRecords_event_CampaignBroadMatchEvent | userActionLogContextQuery_userActionLog_logRecords_event_CampaignNetworkEvent | userActionLogContextQuery_userActionLog_logRecords_event_CampaignRegionsEvent | userActionLogContextQuery_userActionLog_logRecords_event_AdGroupsRegionsEvent | userActionLogContextQuery_userActionLog_logRecords_event_DemographyMultipliersEvent | userActionLogContextQuery_userActionLog_logRecords_event_RetargetingMultipliersEvent | userActionLogContextQuery_userActionLog_logRecords_event_BannersEvent | userActionLogContextQuery_userActionLog_logRecords_event_CampaignValueChangeEvent | userActionLogContextQuery_userActionLog_logRecords_event_CampaignListChangeEvent | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStatusChangeEvent | userActionLogContextQuery_userActionLog_logRecords_event_CampaignStrategyEvent | userActionLogContextQuery_userActionLog_logRecords_event_SingleMultiplierEvent | userActionLogContextQuery_userActionLog_logRecords_event_CampaignRestrictFrequencyEvent;

export interface userActionLogContextQuery_userActionLog_logRecords {
  __typename: "LogRecord";
  datetime: GraphQlLocalDateTime;
  user: userActionLogContextQuery_userActionLog_logRecords_user;
  changeSource: ChangeSource;
  gtid: string | null;
  event: userActionLogContextQuery_userActionLog_logRecords_event;
}

export interface userActionLogContextQuery_userActionLog {
  __typename: "UserActionLogContext";
  nextPageToken: string | null;
  logRecords: userActionLogContextQuery_userActionLog_logRecords[];
}

export interface userActionLogContextQuery {
  userActionLog: userActionLogContextQuery_userActionLog;
}

export interface userActionLogContextQueryVariables {
  clientLogin?: string | null;
  campaignIds?: GraphQlLong[] | null;
  adGroupIds?: GraphQlLong[] | null;
  adIds?: GraphQlLong[] | null;
  logins?: string[] | null;
  limit?: number | null;
  token?: string | null;
  dateFrom?: GraphQlLocalDateTime | null;
  dateTo?: GraphQlLocalDateTime | null;
  categories?: CategoryInput[] | null;
  order?: OrderInput | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BroadmatchFragment
// ====================================================

export interface BroadmatchFragment_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface BroadmatchFragment {
  __typename: "BroadMatchView";
  enabled: boolean;
  isLimitDefined: boolean;
  limit: number;
  goal: BroadmatchFragment_goal;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TimeTargetFragment
// ====================================================

export interface TimeTargetFragment_timeZone {
  __typename: "TimeZoneView";
  id: GraphQlLong;
  name: string | null;
}

export interface TimeTargetFragment {
  __typename: "TimeTargetView";
  timeZone: TimeTargetFragment_timeZone;
  monday: (number | null)[];
  tuesday: (number | null)[];
  wednesday: (number | null)[];
  thursday: (number | null)[];
  friday: (number | null)[];
  saturday: (number | null)[];
  sunday: (number | null)[];
  workingWeekend: (number | null)[];
  holiday: (number | null)[];
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NetworkFragment
// ====================================================

export interface NetworkFragment {
  __typename: "NetworkView";
  type: NetworkViewType;
  limitPercent: number;
  priceCoef: number;
  enableCpcHold: boolean;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DemographyMultiplierFragment
// ====================================================

export interface DemographyMultiplierFragment {
  __typename: "DemographyMultiplierView";
  age: Age;
  gender: Gender;
  multiplier: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RetargetingFragment
// ====================================================

export interface RetargetingFragment {
  __typename: "RetargetingMultiplierView";
  retargetingConditionId: GraphQlLong;
  retargetingConditionName: string;
  multiplier: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RestrictFrequencyFragment
// ====================================================

export interface RestrictFrequencyFragment {
  __typename: "RestrictFrequencyView";
  value: number;
  reset: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FlatStrategyFragment
// ====================================================

export interface FlatStrategyFragment_GdCampaignStrategyAvgCpa_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgCpa_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgCpa {
  __typename: "GdCampaignStrategyAvgCpa";
  type: GdCampaignStrategyType;
  goalId: GraphQlLong | null;
  goal: FlatStrategyFragment_GdCampaignStrategyAvgCpa_goal;
  bid: GraphQlBigDecimal | null;
  avgCpa: GraphQlBigDecimal | null;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: FlatStrategyFragment_GdCampaignStrategyAvgCpa_budget | null;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgCpaPerFilter_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgCpaPerFilter_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgCpaPerFilter {
  __typename: "GdCampaignStrategyAvgCpaPerFilter";
  type: GdCampaignStrategyType;
  filterAvgCpa: GraphQlBigDecimal | null;
  filterAvgBid: GraphQlBigDecimal | null;
  goalId: GraphQlLong | null;
  goal: FlatStrategyFragment_GdCampaignStrategyAvgCpaPerFilter_goal;
  bid: GraphQlBigDecimal | null;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: FlatStrategyFragment_GdCampaignStrategyAvgCpaPerFilter_budget | null;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgCpcPerFilter_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgCpcPerFilter {
  __typename: "GdCampaignStrategyAvgCpcPerFilter";
  type: GdCampaignStrategyType;
  bid: GraphQlBigDecimal | null;
  filterAvgBid: GraphQlBigDecimal | null;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: FlatStrategyFragment_GdCampaignStrategyAvgCpcPerFilter_budget | null;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgCpaPerCamp_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgCpaPerCamp_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgCpaPerCamp {
  __typename: "GdCampaignStrategyAvgCpaPerCamp";
  type: GdCampaignStrategyType;
  goalId: GraphQlLong | null;
  goal: FlatStrategyFragment_GdCampaignStrategyAvgCpaPerCamp_goal;
  bid: GraphQlBigDecimal | null;
  avgCpa: GraphQlBigDecimal | null;
  avgBid: GraphQlBigDecimal | null;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: FlatStrategyFragment_GdCampaignStrategyAvgCpaPerCamp_budget | null;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgCpcPerCamp_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgCpcPerCamp {
  __typename: "GdCampaignStrategyAvgCpcPerCamp";
  type: GdCampaignStrategyType;
  bid: GraphQlBigDecimal | null;
  avgBid: GraphQlBigDecimal | null;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: FlatStrategyFragment_GdCampaignStrategyAvgCpcPerCamp_budget | null;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgClick_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgClick {
  __typename: "GdCampaignStrategyAvgClick";
  type: GdCampaignStrategyType;
  avgBid: GraphQlBigDecimal | null;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: FlatStrategyFragment_GdCampaignStrategyAvgClick_budget | null;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgCpm_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgCpm {
  __typename: "GdCampaignStrategyAvgCpm";
  type: GdCampaignStrategyType;
  avgCpm: GraphQlBigDecimal | null;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: FlatStrategyFragment_GdCampaignStrategyAvgCpm_budget | null;
}

export interface FlatStrategyFragment_GdCampaignStrategyWeekBudget_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface FlatStrategyFragment_GdCampaignStrategyWeekBudget_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface FlatStrategyFragment_GdCampaignStrategyWeekBudget {
  __typename: "GdCampaignStrategyWeekBudget";
  type: GdCampaignStrategyType;
  bid: GraphQlBigDecimal | null;
  goalId: GraphQlLong | null;
  goal: FlatStrategyFragment_GdCampaignStrategyWeekBudget_goal;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: FlatStrategyFragment_GdCampaignStrategyWeekBudget_budget | null;
}

export interface FlatStrategyFragment_GdCampaignStrategyWeekBundle_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface FlatStrategyFragment_GdCampaignStrategyWeekBundle {
  __typename: "GdCampaignStrategyWeekBundle";
  type: GdCampaignStrategyType;
  clicksLimit: GraphQlLong | null;
  bid: GraphQlBigDecimal | null;
  avgBid: GraphQlBigDecimal | null;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: FlatStrategyFragment_GdCampaignStrategyWeekBundle_budget | null;
}

export interface FlatStrategyFragment_GdCampaignStrategyRoi_goal {
  __typename: "Goal";
  id: GraphQlLong | null;
  name: string;
}

export interface FlatStrategyFragment_GdCampaignStrategyRoi_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface FlatStrategyFragment_GdCampaignStrategyRoi {
  __typename: "GdCampaignStrategyRoi";
  type: GdCampaignStrategyType;
  profitability: GraphQlBigDecimal | null;
  roiCoef: GraphQlBigDecimal | null;
  goalId: GraphQlLong | null;
  goal: FlatStrategyFragment_GdCampaignStrategyRoi_goal;
  bid: GraphQlBigDecimal | null;
  reserveReturn: GraphQlLong | null;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: FlatStrategyFragment_GdCampaignStrategyRoi_budget | null;
}

export interface FlatStrategyFragment_GdCampaignStrategyManual_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface FlatStrategyFragment_GdCampaignStrategyManual {
  __typename: "GdCampaignStrategyManual";
  type: GdCampaignStrategyType;
  separateBidding: boolean | null;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: FlatStrategyFragment_GdCampaignStrategyManual_budget | null;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgCpi_budget {
  __typename: "GdCampaignBudget";
  autoProlongation: boolean | null;
  start: GraphQlLocalDate | null;
  finish: GraphQlLocalDate | null;
  period: GdCampaignBudgetPeriod;
  showMode: GdCampaignBudgetShowMode;
  sum: GraphQlBigDecimal;
}

export interface FlatStrategyFragment_GdCampaignStrategyAvgCpi {
  __typename: "GdCampaignStrategyAvgCpi";
  type: GdCampaignStrategyType;
  bid: GraphQlBigDecimal | null;
  avgCpi: GraphQlBigDecimal;
  platform: GdCampaignPlatform;
  isAutoBudget: boolean;
  budget: FlatStrategyFragment_GdCampaignStrategyAvgCpi_budget | null;
}

export type FlatStrategyFragment = FlatStrategyFragment_GdCampaignStrategyAvgCpa | FlatStrategyFragment_GdCampaignStrategyAvgCpaPerFilter | FlatStrategyFragment_GdCampaignStrategyAvgCpcPerFilter | FlatStrategyFragment_GdCampaignStrategyAvgCpaPerCamp | FlatStrategyFragment_GdCampaignStrategyAvgCpcPerCamp | FlatStrategyFragment_GdCampaignStrategyAvgClick | FlatStrategyFragment_GdCampaignStrategyAvgCpm | FlatStrategyFragment_GdCampaignStrategyWeekBudget | FlatStrategyFragment_GdCampaignStrategyWeekBundle | FlatStrategyFragment_GdCampaignStrategyRoi | FlatStrategyFragment_GdCampaignStrategyManual | FlatStrategyFragment_GdCampaignStrategyAvgCpi;

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum Age {
  age_0_17 = "age_0_17",
  age_18_24 = "age_18_24",
  age_25_34 = "age_25_34",
  age_35_44 = "age_35_44",
  age_45_54 = "age_45_54",
  age_45_inf = "age_45_inf",
  age_55_inf = "age_55_inf",
  any = "any",
}

export enum CalcType {
  CPC = "CPC",
  CPM = "CPM",
}

export enum CategoryInput {
  ADGROUP_REGIONS = "ADGROUP_REGIONS",
  BANNERS_ARCHIVED = "BANNERS_ARCHIVED",
  BANNERS_HIDE = "BANNERS_HIDE",
  BANNERS_SHOW = "BANNERS_SHOW",
  BANNERS_STATUS = "BANNERS_STATUS",
  BANNERS_UNARCHIVED = "BANNERS_UNARCHIVED",
  CAMPAIGN_ARCHIVED = "CAMPAIGN_ARCHIVED",
  CAMPAIGN_BROAD_MATCH = "CAMPAIGN_BROAD_MATCH",
  CAMPAIGN_CREATION = "CAMPAIGN_CREATION",
  CAMPAIGN_DISABLED_DOMAINS = "CAMPAIGN_DISABLED_DOMAINS",
  CAMPAIGN_DISABLED_IPS = "CAMPAIGN_DISABLED_IPS",
  CAMPAIGN_DISABLED_SSP = "CAMPAIGN_DISABLED_SSP",
  CAMPAIGN_EXTENDED_GEOTARGETING = "CAMPAIGN_EXTENDED_GEOTARGETING",
  CAMPAIGN_FINISH_TIME = "CAMPAIGN_FINISH_TIME",
  CAMPAIGN_HIDE = "CAMPAIGN_HIDE",
  CAMPAIGN_MINUS_WORDS = "CAMPAIGN_MINUS_WORDS",
  CAMPAIGN_NETWORK = "CAMPAIGN_NETWORK",
  CAMPAIGN_REGIONS = "CAMPAIGN_REGIONS",
  CAMPAIGN_RESTRICT_FREQUENCY = "CAMPAIGN_RESTRICT_FREQUENCY",
  CAMPAIGN_SHOW = "CAMPAIGN_SHOW",
  CAMPAIGN_START_TIME = "CAMPAIGN_START_TIME",
  CAMPAIGN_STATUS = "CAMPAIGN_STATUS",
  CAMPAIGN_STRATEGY = "CAMPAIGN_STRATEGY",
  CAMPAIGN_TIME_TARGET = "CAMPAIGN_TIME_TARGET",
  CAMPAIGN_UNARCHIVED = "CAMPAIGN_UNARCHIVED",
  DEMOGRAPHY_MULTIPLIERS = "DEMOGRAPHY_MULTIPLIERS",
  HIERARCHICAL_MULTIPLIERS = "HIERARCHICAL_MULTIPLIERS",
  MOBILE_MULTIPLIER = "MOBILE_MULTIPLIER",
  PERFORMANCE_TGO_MULTIPLIER = "PERFORMANCE_TGO_MULTIPLIER",
  REGIONS = "REGIONS",
  RETARGETING_MULTIPLIERS = "RETARGETING_MULTIPLIERS",
  VIDEO_MULTIPLIER = "VIDEO_MULTIPLIER",
}

export enum ChangeSource {
  API_APP = "API_APP",
  COMMANDER = "COMMANDER",
  DIRECT_MOBILE_APP = "DIRECT_MOBILE_APP",
  OTHER = "OTHER",
  WEB = "WEB",
  XLS = "XLS",
}

export enum CurrencyCode {
  BYN = "BYN",
  CHF = "CHF",
  EUR = "EUR",
  KZT = "KZT",
  RUB = "RUB",
  TRY = "TRY",
  UAH = "UAH",
  USD = "USD",
  YND_FIXED = "YND_FIXED",
}

export enum GdCampaignBudgetPeriod {
  CUSTOM = "CUSTOM",
  DAY = "DAY",
  WEEK = "WEEK",
}

export enum GdCampaignBudgetShowMode {
  DEFAULT = "DEFAULT",
  STRETCHED = "STRETCHED",
}

export enum GdCampaignPlatform {
  BOTH = "BOTH",
  CONTEXT = "CONTEXT",
  SEARCH = "SEARCH",
}

export enum GdCampaignStrategyType {
  AVG_CLICK = "AVG_CLICK",
  AVG_CPA = "AVG_CPA",
  AVG_CPA_PER_CAMP = "AVG_CPA_PER_CAMP",
  AVG_CPA_PER_FILTER = "AVG_CPA_PER_FILTER",
  AVG_CPC_PER_CAMP = "AVG_CPC_PER_CAMP",
  AVG_CPC_PER_FILTER = "AVG_CPC_PER_FILTER",
  AVG_CPI = "AVG_CPI",
  CPM_DEFAULT = "CPM_DEFAULT",
  CPM_MAX_IMPRESSIONS = "CPM_MAX_IMPRESSIONS",
  CPM_MAX_IMPRESSIONS_CUSTOM_PERIOD = "CPM_MAX_IMPRESSIONS_CUSTOM_PERIOD",
  CPM_MAX_REACH = "CPM_MAX_REACH",
  CPM_MAX_REACH_CUSTOM_PERIOD = "CPM_MAX_REACH_CUSTOM_PERIOD",
  DEFAULT = "DEFAULT",
  NO_PREMIUM = "NO_PREMIUM",
  ROI = "ROI",
  WEEK_BUDGET = "WEEK_BUDGET",
  WEEK_BUNDLE = "WEEK_BUNDLE",
}

export enum Gender {
  any = "any",
  female = "female",
  male = "male",
}

export enum NetworkViewType {
  disabled = "disabled",
  not_limited = "not_limited",
  percent = "percent",
}

export enum OrderInput {
  ASC = "ASC",
  DESC = "DESC",
}

export enum OutputCategory {
  ADGROUP_DEMOGRAPHY_MULTIPLIERS = "ADGROUP_DEMOGRAPHY_MULTIPLIERS",
  ADGROUP_MOBILE_MULTIPLIER = "ADGROUP_MOBILE_MULTIPLIER",
  ADGROUP_PERFORMANCE_TGO_MULTIPLIER = "ADGROUP_PERFORMANCE_TGO_MULTIPLIER",
  ADGROUP_REGIONS = "ADGROUP_REGIONS",
  ADGROUP_RETARGETING_MULTIPLIERS = "ADGROUP_RETARGETING_MULTIPLIERS",
  ADGROUP_VIDEO_MULTIPLIER = "ADGROUP_VIDEO_MULTIPLIER",
  BANNERS_ARCHIVED = "BANNERS_ARCHIVED",
  BANNERS_HIDE = "BANNERS_HIDE",
  BANNERS_SHOW = "BANNERS_SHOW",
  BANNERS_UNARCHIVED = "BANNERS_UNARCHIVED",
  CAMPAIGN_ARCHIVED = "CAMPAIGN_ARCHIVED",
  CAMPAIGN_BROAD_MATCH = "CAMPAIGN_BROAD_MATCH",
  CAMPAIGN_CREATION = "CAMPAIGN_CREATION",
  CAMPAIGN_DEMOGRAPHY_MULTIPLIERS = "CAMPAIGN_DEMOGRAPHY_MULTIPLIERS",
  CAMPAIGN_DISABLED_DOMAINS = "CAMPAIGN_DISABLED_DOMAINS",
  CAMPAIGN_DISABLED_IPS = "CAMPAIGN_DISABLED_IPS",
  CAMPAIGN_DISABLED_SSP = "CAMPAIGN_DISABLED_SSP",
  CAMPAIGN_EXTENDED_GEOTARGETING = "CAMPAIGN_EXTENDED_GEOTARGETING",
  CAMPAIGN_FINISH_TIME = "CAMPAIGN_FINISH_TIME",
  CAMPAIGN_HIDE = "CAMPAIGN_HIDE",
  CAMPAIGN_MINUS_WORDS = "CAMPAIGN_MINUS_WORDS",
  CAMPAIGN_MOBILE_MULTIPLIER = "CAMPAIGN_MOBILE_MULTIPLIER",
  CAMPAIGN_NETWORK = "CAMPAIGN_NETWORK",
  CAMPAIGN_PERFORMANCE_TGO_MULTIPLIER = "CAMPAIGN_PERFORMANCE_TGO_MULTIPLIER",
  CAMPAIGN_REGIONS = "CAMPAIGN_REGIONS",
  CAMPAIGN_RESTRICT_FREQUENCY = "CAMPAIGN_RESTRICT_FREQUENCY",
  CAMPAIGN_RETARGETING_MULTIPLIERS = "CAMPAIGN_RETARGETING_MULTIPLIERS",
  CAMPAIGN_SHOW = "CAMPAIGN_SHOW",
  CAMPAIGN_START_TIME = "CAMPAIGN_START_TIME",
  CAMPAIGN_STRATEGY = "CAMPAIGN_STRATEGY",
  CAMPAIGN_TIME_TARGET = "CAMPAIGN_TIME_TARGET",
  CAMPAIGN_UNARCHIVED = "CAMPAIGN_UNARCHIVED",
  CAMPAIGN_VIDEO_MULTIPLIER = "CAMPAIGN_VIDEO_MULTIPLIER",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
